<template>
    <div :class="{'head text-center d-md-flex flex-md-column align-items-center':true, 'd-none':isLogged}">
        <h2 v-if="!displayNavigation" class="game-title">{{ `titles.${gameName}` | lang }}</h2>
        <h5 class="order-1 d-none d-md-block font-weight-semi-bold">{{ 'timer.win' | lang }} {{ maxWinAmount | currency({"roundIntegers":true}) }}</h5>
        <spinner class="order-2 order-md-2 d-none d-md-block" v-if="isLive" :label="'live' | lang" progress="1"></spinner>
        <spinner class="order-2 order-md-2 font-weight-semi-bold d-none d-md-block" v-else :progress="progress" :seconds-left="secondsLeft"></spinner>
        <div class="mt-2 order-3 order-md-3 ml-3 ml-md-0">
            <h5 class="d-md-none">{{ 'timer.win' | lang }} {{ maxWinAmount | currency({"roundIntegers":true}) }}</h5>
            <div class="mb-3">{{ 'timer.alternator.live' | lang }}</div>
            <b-button variant="success" v-if="!isLogged" @click="redirectLoginHandler" class="font-weight-semi-bold text-capitalize">{{ 'login' | lang }} / {{ 'register' | lang }}</b-button>
            <b-button variant="success" v-else @click="showPurchase" class="font-weight-semi-bold">{{ 'buy_a_ticket' | lang }}</b-button>
        </div>
    </div>
</template>

<script>
import Spinner from './Spinner';
import { mapState, mapGetters } from 'vuex';
import moment from "moment";
import { redirectLogin } from "@tv/helpers";

export default {
    props: ['gameId'],

    components: { Spinner },

    computed: {
        ...mapState(['channels', 'datetime', 'isLogged', 'pools', 'displayNavigation']),
        ...mapGetters(['maxWinByGame']),

        gameName() {
          return Config.games[this.gameId].name;
        },

        maxWinAmount() {
            return this.$store.getters.maxWinByGame(this.gameId);
        },

        progress() {
            return 1 - this.secondsLeft / (60 * 5);
        },

        isLive() {
            return this.secondsLeft <= 0;
        },

        secondsLeft() {
            const channelId = Config.games[this.gameId].channel_id;
            return this.$store.getters.remaining(channelId);
        },
    },

    methods: {
        showPurchase() {
            const $el = document.querySelector('.purchase');
            const scroll_to = $el.getBoundingClientRect().top;

            if (window.parent !== window.self) {
                parent.postMessage({ scroll_to }, '*');
            } else {
              const scrollStep = (scroll_to - window.scrollY) / 25;
              let step = 0;

              const scrollInterval = setInterval(() => {
                window.scrollBy(0, scrollStep);
                step++;

                if (step >= 25)
                  clearInterval(scrollInterval);
              }, 15);
            }
        },

        redirectLoginHandler() {
            redirectLogin();
        }
    },
}
</script>
